<template>
  <div>
    <z-container>
      <!-- <h3 class="headline mb-3">Lista de Lotes</h3> -->
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-items>
            <v-btn
              id="btn-adicionar"
              text
              small
              color="primary"
              @click="adicionar"
              :disabled="!$auth.temPermissao('lotes_cadastrar')"
            >
              <v-icon left>mdi-plus</v-icon>Adicionar
            </v-btn>
            <v-btn
              id="btAtualizar"
              text
              small
              @click="refresh"
              :loading="$store.state.loading"
            >
              <v-icon>refresh</v-icon>
              <v-tooltip bottom activator="#btAtualizar">
                Atualizar
              </v-tooltip>
            </v-btn>
          </v-toolbar-items>

          <!-- <v-spacer></v-spacer> -->

          <div style="width: 300px;" class="ml-5">
            <!-- <v-text-field rounded filled single-line dense label="Pesquisar" autofocus clearable hide-details prepend-inner-icon="search" v-model="search"></v-text-field> -->
            <v-text-field
              rounded
              filled
              single-line
              dense
              label="Pesquisar"
              autofocus
              clearable
              hide-details
              prepend-inner-icon="search"
              v-model="search"
              @keydown.enter="refresh"
              @click:clear="limparBusca"
            ></v-text-field>
          </div>
        </v-toolbar>

        <v-divider></v-divider>

        <v-data-table
          :headers="headers"
          :items="lotes"
          item-key="id"
          :loading="false"
          :search="search"
          :options.sync="options"
          :server-items-length="total_de_registros"
          :footer-props="$globals.FOOTER_PROPS"
        >
          <template v-slot:item="{ item: lote }">
            <tr>
              <td>{{ lote.id }}</td>
              <td>{{ lote.descricao }}</td>
              <td class="text-center">
                <v-btn title="Editar" icon @click="editar(lote)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn title="Excluir" icon @click="perguntarExcluir(lote)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo-sim-nao
      ref="dialogoRemoverLote"
      titulo="Remover lote?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O lote <b>{{ lote.descricao }}</b> será removido.
    </z-dialogo-sim-nao>

    <lotes-form ref="dialogoLotesForm"></lotes-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import LotesForm from "./LotesForm";
export default {
  name: "LotesLista",
  components: {
    LotesForm,
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Descrição", value: "descricao" },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      excluindo: false,
      lote: {},
    };
  },

  created() {
    this.setTitulo("Cadastro de Lotes");
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("lotes", ["listar", "excluir", "abrir"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erroSistema("Não foi possível obter a lista de lotes.");
        throw error;
      }
    },

    adicionar() {
      this.$store.commit("lotes/ZERAR");
      this.$refs.dialogoLotesForm.abrir();
    },

    async editar(lote) {
      try {
        await this.abrir(lote.id);
        this.$refs.dialogoLotesForm.abrir();
      } catch (error) {
        this.$eventbus.notificar("Não foi possível editar o lote.");
      } finally {
        this.LOADING_OFF();
      }
    },

    perguntarExcluir(lote) {
      this.lote = lote;
      this.$refs.dialogoRemoverLote.abrir().then(async (response) => {
        if (response == true) {
          await this.confirmarExcluir();
        }
      });
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.lote.id);
        this.$refs.dialogoRemoverLote.fechar();
        this.$eventbus.notificar("Lote excluído com sucesso!");
      } catch (error) {
        if (error.response) {
          this.$eventbus.erroSistema(error?.response?.data?.message);
        } else {
          this.$eventbus.erroSistema("Não foi possível excluir lote!");
        }
      } finally {
        this.excluindo = false;
      }
    },

    limparBusca() {
      this.search = "";
      this.$store.commit("lotes/SET_PAGE", 1);
      this.refresh();
    },
  },

  computed: {
    ...mapState("lotes", ["lotes", "pagination", "total_de_registros"]),

    search: {
      get() {
        return this.$store.state.lotes.search;
      },
      set(search) {
        this.$store.commit("lotes/SET_SEARCH", search);
      },
    },

    options: {
      get() {
        return this.$store.state.lotes.pagination;
      },
      set(options) {
        this.$store.commit("lotes/UPDATE_PAGINATION", options);
      },
    },
  },

  watch: {
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
